<template>
  <lego-modal-extend-v-2
    ref="modal"
    :title="$t('menu.addEventPolicy')"
    :custom-style="customStyle"
    @beforeClose="back"
  >
    <div class="content-wrapper">
      <monitoring-target-common
        :productCodes="resourceTypeItems"
        :productTypeGroups="productTypeGroups"
        :subProductCodes="search1Codes.sch01"
        :defaultProductCode="resourceTypeModel"
        :defaultSubProductCode="resourceTypeModel2"
        :selectedItems="listChips"
        :dropdownStyle="{ width: '800px', height: '694px', padding: '24px' }"
        requiredAsterisk
        :title="resourceTypeModel === 'VM' ? $t('searchLabel.monitoringTargetAsg') : ''"
        :isDisabledBtn="isDisabledBtn || !isPassAuthorization"
        @change-product-type-code="selectResourceType"
        @change-sub-type-code="selectResourceType2"
        @open-drop-down="addMonitorClick"
        @confirm-dialog="onConfirmAdd"
        @remove="removeTarget"
        @close-dialog="closeDialog"
      >
        <template v-if="isVirtualServerPropduct">
          <lego-tab-box
            style="margin-bottom: 16px"
            :default-idx="typeIndex"
            @tab-change="onChangeTabType"
          >
            <lego-tab-label class="" :idx="1">
              <div class="wrap-title-tab-box">
                {{ $t('title.monTarget') }}
                <div class="badge-selected" v-if="productsModel.length">
                  {{ productsModel.length }}
                </div>
              </div>
            </lego-tab-label>
            <lego-tab-label class="" :idx="2">
              <div class="wrap-title-tab-box">
                ASG (VM)
                <div class="badge-selected" v-if="selectedASG.length">{{ selectedASG.length }}</div>
              </div>
            </lego-tab-label>
          </lego-tab-box>
          <add-monitor-target
            v-if="typeIndex == 1"
            ref="addMonitorTarget"
            :monitorInfo="popup.addMonitorVmProps"
            :selected="productsModel"
            @selected-list="onSelectedList"
            :selectMaxItem="getNumberMaxItem"
            isSelectAsg
          />
          <add-monitor-asg
            v-else
            ref="addMonitorAsg"
            :placeholder="$t('searchLabel.searchLike', { VPC: $t('searchLabel.asgVM') })"
            :productType="resourceTypeModel"
            :selected="selectedASG"
            @selected-list="onSelectedASG"
            :selectMaxItem="getNumberMaxItem"
          />
        </template>
        <add-monitor-target
          v-else
          :monitorInfo="popup.addMonitorVmProps"
          @selected-list="onSelectedList"
          :selectMaxItem="30"
          :selected="productsModel"
          class="add-monitor-target"
        />
      </monitoring-target-common>

      <scpm-divider style="margin: 0" />

      <div class="tab-wrapper">
        <lego-tab-box class="tabbox" :default-idx="tabIndex" @tab-change="tabChange">
          <lego-tab-label class="tabbox-item" :idx="1"
            >{{ t('page.eventStatus.eventConditionTab') }}
          </lego-tab-label>
          <lego-tab-label class="tabbox-item" :idx="2"
            >{{ t('label.notification') }}
          </lego-tab-label>
        </lego-tab-box>
        <div class="action-wrapper">
          <lego-button @click="onOpenFindTemplateModal" :disabled="isDisabledBtn">
            {{ t('page.eventStatus.findEventTemplate') }}
          </lego-button>
        </div>
      </div>

      <div class="tabs-container">
        <div
          class="event-rule"
          :class="{ 'disable-click-title': !listChips.length }"
          v-show="tabIndex === 1"
        >
          <EventRule
            v-if="isShowEventRule"
            v-model="eventRules"
            :productsModel="productsModel"
            :selectedASG="selectedASG"
            :metric="metric"
            :resourceTypeModel="resourceTypeModel"
            :resourceTypeModel2="resourceTypeModel2"
            ref="rule"
            :sch01="search1Codes.sch01"
            :chkMode="chkMode"
            :chkMetricItems="chkMetricItems"
            @setMetricItems="setMetricItems"
            :isAddEventPolicy="false"
            @setNotification="setNotificationTemplate"
            @resetRules="initial"
            @update:Validate="(value) => (this.validateRules = value)"
          />
        </div>
        <div class="notification-target" :class="{ 'notification-target__active': tabIndex === 2 }">
          <alarm-user-setting
            ref="alarm"
            :hasTitle="false"
            :openingPopupOther="openingPopupMonTarget"
            class="event-alarm__setting"
            :alarmInfos="notificationsModel"
            @user-selected="selectedUsers"
            @clickDeselection="removeNotification"
          />
          <notifications-table
            ref="notifications"
            :valueTmp="notificationsModel"
            :maxRowTable="maxRowTable"
            :rules="eventRules"
            @remove-item="removeItem"
            @selectMethod="selectMethod"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <lego-button @click="back" border>{{ t('button.cancel') }}</lego-button>
      <!-- 취소 -->
      <lego-button :disabled="disableConfirm" main @click="onConfirm"
        >{{ t('button.save') }}
      </lego-button>
      <!-- 확인 -->
    </template>
  </lego-modal-extend-v-2>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import EventRule from './components/EventRule';
import validationMixin from '@/mixins/validation.mixin.js';
import { convertToGroups } from '@/containers/utils/utils.js';
import MonitoringTargetCommon from '@/containers/components/MonitoringTargetCommon.vue';
import AddMonitorTarget from '../../performance/AddMonitorTarget.vue';
import LegoModalExtendV2 from '@/components/lego/extend/legoModalExtendV2.vue';
import NotificationsTable from '@/containers/event/eventSettings/components/NotificationsTable.vue';
import AlarmUserSetting from '@/containers/event/eventSettings/components/AlarmUserSetting.vue';
import validateFieldsMixin from '@/mixins/validateFields.mixin';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
import { EVENT_LEVELS, KUBERNETES, LOAD_BALANCER } from '@/containers/utils/constant.js';
import AddMonitorAsg from './components/AddMonitorASG.vue';
import { computed } from 'vue';
import { useProductTypeGroups } from '@/composables/useProductTypeGroups.js';
import { handleValidPolicy } from './utils/eventCommon';

const { getProductTypeGroups } = useProductTypeGroups();

export default {
  mixins: [validationMixin, i18nMixin, validateFieldsMixin],
  emits: ['confirm', 'close'],
  props: {
    openModal: {
      type: Boolean,
      default: () => false
    },
    productTypeCode: {
      type: String,
      required: true
    },
    selectedTarget: {
      type: Object,
      default: null
    },
    subProductCode: {
      type: String,
      default: null
    },
    isPerformance: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EventRule,
    MonitoringTargetCommon,
    AddMonitorTarget,
    LegoModalExtendV2,
    NotificationsTable,
    AlarmUserSetting,
    AddMonitorAsg
  },
  computed: {
    getNumberMaxItem() {
      const numMax = 30;

      if (this.typeIndex === 1 && this.selectedASG.length) {
        return numMax - this.selectedASG.length;
      } else if (this.typeIndex === 2 && this.productsModel.length) {
        return numMax - this.productsModel.length;
      }

      return numMax;
    },
    disableConfirm() {
      // Check valid => pass validate fields || field data is changed || if notification, the method must be selected
      return !this.validateSubmit || !this.changedFieldData || this.isDisableHaveNoMethod;
    },

    maxRowTable() {
      return this.is2ndDropDown ? 4.5 : 5.7;
    },
    isDisableHaveNoMethod() {
      return !!this.notificationsModel.filter((data) =>
        data.notificationMethods.some(
          (noti) => this.eventLevelSet.includes(noti.eventLevel) && noti.sendMethod.length === 0
        )
      ).length;
    },
    eventLevelSet() {
      if (!this.eventRules || !this.eventRules.length) return [];
      let result = [];

      EVENT_LEVELS.forEach((eventLevel) => {
        let event = this.eventRules.find((item) => item.eventLevel == eventLevel);
        if (event) {
          result.push(eventLevel);
        }
      });

      return result;
    },
    lblObjectType() {
      if (this.resourceTypeModel == 'Kubernetes') {
        return 'Cluster';
      } else if (this.lstSubResourceType.includes(this.resourceTypeModel)) {
        return 'Service';
      }
      return '';
    },
    is2ndDropDown() {
      this.secondDropDownSetting();
      return this.lstSubResourceType.includes(this.resourceTypeModel) ? true : false;
    },
    isVirtualServerPropduct() {
      return this.resourceTypeModel === 'VM';
    },
    isExistSelectedTarget() {
      return this.listChips;
    }
  },
  watch: {
    is2ndDropDown(value) {
      this.showSubResource = value;
    },
    eventRules: {
      handler() {
        this.isCheckChangeData = true;
        this.validateForSubmit();
        if (this.isPerformance) {
          this.setFieldsBeforeModify();
        }
      },
      deep: true,
      immediate: false
    },
    isExistSelectedTarget: {
      handler() {
        this.validateForSubmit();
        this.$nextTick(() => {
          if (this.$refs.rule) {
            this.$refs.rule.handlerValidateRules();
          }
        });
      },
      deep: true
    },
    validateRules: {
      handler() {
        this.validateForSubmit();
      },
      deep: true
    },
    selectedTarget: {
      handler(newValue) {
        if (newValue) {
          if (newValue.targets.length) {
            // Need check props from other page
            this.listChips = newValue.targets;
            this.productsModel = newValue.targets;
          }
          if (newValue.metric) this.metric = newValue.metric;
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isShowEventRule: false,
      isShowMessageNoProductType: false,
      validateFieldKey: 'eventSettingAdd',
      metric: null,
      usersSelected: [],
      tabIndex: 1,
      typeIndex: 1,
      isCheckChangeData: false,
      showSubResource: false,
      productTypeGroups: [],
      showAddUserModal: false,
      resourceTypeItems: [],
      lstSubResourceType: [KUBERNETES, LOAD_BALANCER],
      subResourceTypeData: {},
      resourceTypeModel: '',
      prevResourceTypeModel: '',
      resourceTypeModel2: '',
      prevResourceTypeModel2: '',
      productsModel: [],
      eventRules: [],
      notificationsModel: [],
      isDisabledBtn: false,
      popup: {
        addMonitorVmProps: {
          pProductTypeCode: '',
          pProductTypeName: '',
          pProductTypeCodes: [],
          pObjectTypeCode: ''
        }
      },
      search1Codes: {
        sch01: []
      },
      preSch01: [],
      noDataText: this.t('page.eventStatus.noMonitoringTarget'),
      tmpK8s: [],
      tmpLb: [],
      chkMode: 'add',
      chkMetricItems: false,
      selectedItems: [],
      customStyle: {
        body: {
          padding: '24px 0',
          overflowY: 'hidden'
        }
      },
      validateRules: false,
      validateSubmit: false,
      listChips: [],
      selectedASG: [],
      beforeProductsModel: [],
      beforeSelectedASG: [],
      openingPopupMonTarget: false,
      isPassAuthorization: false
    };
  },
  provide() {
    return {
      isShowMessageNoProductType: computed(() => this.isShowMessageNoProductType)
    };
  },
  async created() {
    await this.secondDropDownDataSetting();
    this.getSubProductype();

    await this.getData();
  },
  mounted() {
    this.$refs['modal'].open();
    if (this.productsModel.length > 0) {
      this.beforeProductsModel = this.$util.deepCopy(this.productsModel);
    }
    if (!this.isPerformance) {
      this.setFieldsBeforeModify();
    }
  },
  methods: {
    selectMethod(data) {
      this.notificationsModel = this.$util.deepCopy(data);
    },
    setNotificationTemplate(data) {
      this.notificationsModel = data.contents;
      this.$refs.alarm.setNotifications(data.contents, true);
    },
    removeNotification(selected) {
      if (selected.length === 0 && this.$refs.notifications !== undefined) {
        this.$refs.notifications.selected = [];
      }
    },
    removeItem(data) {
      this.$refs.alarm.deleteItem(data.selected);
    },
    selectedUsers(users) {
      if (this.notificationsModel.length !== users.length) this.isCheckChangeData = true;
      this.usersSelected = [];
      let lenNotificationList = this.notificationsModel.length - 1;
      users.forEach((item) => {
        for (let count = 0; count <= lenNotificationList; count++) {
          if (this.notificationsModel[count].seq == item.seq) {
            item.notificationMethods = this.notificationsModel[count].notificationMethods;
          }
        }
        for (let count = 0; count <= lenNotificationList; count++) {
          if (this.notificationsModel[count].recipientKey == item.seq) {
            item.notificationMethods = this.notificationsModel[count].notificationMethods;
          }
        }
        if (item.notificationMethods === undefined) {
          let _FATAL = { sendMethod: ['MAIL'] };
          let _WARNING = { sendMethod: ['MAIL'] };
          let _INFORM = { sendMethod: ['MAIL'] };

          item.notificationMethods = [
            { eventLevel: 'FATAL', ..._FATAL },
            { eventLevel: 'WARNING', ..._WARNING },
            { eventLevel: 'INFORM', ..._INFORM }
          ];
        }

        item.recipientName = item.name;
        item.recipientKey = item.seq;
        item.recipientType = item.type;
        if (item.type == 'USER') {
          item.userAdditionalInfo = {
            userEmail: item.info,
            userLanguage: '',
            userMobileTelNo: '',
            userTimezone: ''
          };
        } else {
          item.addrbookAdditionalInfo = {
            memberCount: item.count,
            userAdditionalInfo: [{ userName: item.userName }]
          };
        }
        this.usersSelected.push(item);
      });
      this.notificationsModel = this.$util.deepCopy(this.usersSelected);
    },
    onOpenFindTemplateModal() {
      this.$refs.rule.openTemplateModal();
    },
    tabChange(index) {
      this.tabIndex = index;
    },
    onChangeTabType(index) {
      this.typeIndex = index;
    },
    changeData() {
      this.isCheckChangeData = true;
    },
    removeTarget(item) {
      if (!item) {
        this.productsModel = [];
        this.selectedASG = [];
        this.listChips = [];
        this.beforeProductsModel = [];
        this.beforeSelectedASG = [];
      } else {
        this.productsModel = this.productsModel.filter((e) => {
          return (
            e.productResourceId !== item.productResourceId ||
            e.objectDisplayName !== item.objectDisplayName
          );
        });
        this.selectedASG = this.selectedASG.filter((e) => {
          return e.groupIfKey !== item.groupIfKey;
        });

        this.updateListChips();
      }

      this.$nextTick(() => {
        this.$refs.rule.resourceChanged(this.resourceTypeModel, false, false);
      });
    },
    onSelectedList(selectValue) {
      this.isCheckChangeData = true;
      this.productsModel = [...selectValue];
    },
    onSelectedASG(selectValue) {
      this.isCheckChangeData = true;
      this.selectedASG = [...selectValue];
    },
    onConfirmAdd() {
      this.openingPopupMonTarget = false;
      this.productsModel = (this.productsModel || []).map((item) => {
        return {
          ...item,
          value: item.text || item.productName,
          label: item.text || item.productName,
          productResourceId: item.productResourceId || item.resourceId
        };
      });

      this.updateListChips();
      this.addMonitorVmPopupOnConfirm();
    },
    updateListChips() {
      this.listChips = [];
      this.listChips.push(...this.productsModel);
      this.listChips.push(...this.selectedASG);
      this.beforeProductsModel = this.$util.deepCopy(this.productsModel);
      this.beforeSelectedASG = this.$util.deepCopy(this.selectedASG);
    },
    closeDialog() {
      this.openingPopupMonTarget = false;
      this.productsModel = this.$util.deepCopy(this.beforeProductsModel);
      this.selectedASG = this.$util.deepCopy(this.beforeSelectedASG);
      // this.popup.addMonitorVmProps.pProductTypeCodes = this.productsModel;
    },
    _onConfirm() {
      this.$emit('confirm');
    },
    _onClose() {
      this.$emit('close');
    },
    back() {
      legoEventBus.$emit('click-outside');
      this.showMessageWhenChange(this._onClose);
    },
    /**
     * function is checked not use in system
     * */
    goList(data) {
      this.$nextTick(() => {
        this.$router.push({
          name: 'event-settings',
          params: {
            id: typeof data != 'undefined' ? data.contents[0].eventPolicyId : '',
            productTypeCode: this.resourceTypeModel,
            tabIndex: 1
          }
        });
      });
    },
    getNotificationRecipients() {
      let notificationRecipients = [];
      this.notificationsModel.forEach((item) => {
        let recipient = {};
        recipient.notificationMethods = [];
        for (let i in this.eventLevelSet) {
          let level = this.eventLevelSet[i];
          let method = item.notificationMethods.find((noti) => noti.eventLevel == level);
          if (method) {
            recipient.notificationMethods.push(method);
          }
        }
        if (recipient.notificationMethods.length > 0) {
          recipient.recipientKey = item.recipientKey;
          recipient.recipientType = item.recipientType;
          notificationRecipients.push(recipient);
        }
      });
      return notificationRecipients;
    },
    checkTargetForSubmit() {
      return !this.$util.isEmpty(this.selectedASG) || !this.$util.isEmpty(this.productsModel);
    },
    checkEventConditionForSubmit() {
      return !this.$util.isEmpty(this.eventRules);
    },
    validateForSubmit() {
      const validateArr = [];
      validateArr.push(this.checkTargetForSubmit());
      validateArr.push(this.checkEventConditionForSubmit());
      validateArr.push(this.validateRules);
      this.validateSubmit = validateArr.every((invalid) => !!invalid);
    },
    async onConfirm() {
      if (this.$util.isEmpty(this.productsModel) && this.$util.isEmpty(this.selectedASG)) {
        this.$alert(this.t('page.eventStatus.selectMonitoringTarget'));
        return false;
      }
      if (this.$util.isEmpty(this.eventRules)) {
        this.$alert(this.t('page.eventStatus.selectEventConditions'));
        return false;
      }

      for (let i in this.eventRules) {
        let rule = this.eventRules[i];
        if (Number(rule.ftCount) > 3600) {
          this.$alert(this.t('page.eventStatus.numberOccurrences'));
          return false;
        }
      }

      let notificationLen = this.notificationsModel.length;
      if (notificationLen > 20) {
        this.$alert(this.t('page.eventStatus.notificationsRegister'));
        return false;
      }

      if (!this.$refs.rule.validate()) {
        this.tabIndex = 1;
        return false;
      }

      let showToast = true;
      let body = {};
      let eventPolicyRequests = [];
      // 메트릭 정보 : 단일 상품일경우
      // 추가시 하위유형이 있는 경우 개별항목별로 저장되므로 개별항목 dropdown 박스 필요없음 eventRuleItem > "is_object_exist_add"
      if (
        (this.resourceTypeModel === 'Kubernetes' && this.resourceTypeModel2 !== 'cluster') ||
        (['DataOps', 'DataFlow', 'Load Balancer'].includes(this.resourceTypeModel) &&
          this.resourceTypeModel2 !== 'service') ||
        (['QuickQuery', 'DataWrangler'].includes(this.resourceTypeModel) &&
          this.resourceTypeModel2 !== 'namespace')
      ) {
        const reducerTmp = function (accumulator, item) {
          accumulator.push(Number(item.productSq));
          return accumulator;
        };
        const resultTmp = this.productsModel.reduce(reducerTmp, []);
        let countIdx = 0;
        let productsModelCnt = 0;
        for (const item of this.productsModel) {
          for (let i in this.eventRules) {
            let policy = {};
            const rule = this.eventRules[i];
            policy.eventLevel = rule.eventLevel;
            policy.disableYn = rule.disableYn;
            policy.eventMessagePrefix = this.$util.isNotEmpty(rule.prefix) ? rule.prefix : '';

            policy.ftCount = Number(rule.ftCount);
            policy.isLogMetric = rule.isLogMetric ? rule.isLogMetric : 'N';
            policy.metricKey = rule.metricKey;
            policy.objectName = item.objectName;
            policy.objectDisplayName = item.objectDisplayName;
            policy.eventOccurTimeZone = rule.eventOccurTimeZone;
            const hasIndividualItems = rule.individualItems && rule.individualItems.length > 0;
            const isAvalabelIndiItems =
              rule.isObjectExist === 'Y' && rule.disableObject !== 'Y' && hasIndividualItems;
            if (isAvalabelIndiItems) {
              let filteredObj = rule.individualItems.find(
                (item) => item.value === rule.objectModel
              );
              policy.podObjectName = rule.objectModel;
              policy.podObjectDisplayName = filteredObj ? filteredObj.text : rule.objectModel;
            }

            if (this.is2ndDropDown) {
              policy.objectType = item.objectType;
              this.subResourceTypeData[this.resourceTypeModel].forEach((item) => {
                if (item.value == this.resourceTypeModel2) {
                  policy.objectTypeName = item.text;
                }
              });
            } else {
              policy.objectType = '';
              policy.objectTypeName = '';
            }
            const newPolicy = handleValidPolicy(rule, policy);
            eventPolicyRequests.push(newPolicy);
          }

          body.eventPolicyRequests = eventPolicyRequests;
          eventPolicyRequests = [];

          body.notificationRecipients = this.getNotificationRecipients();

          body.productSqs = [];
          body.productSqs[0] = resultTmp[productsModelCnt];

          await (async () => {
            await this.$http.event
              .post('/v1/console/event-policies/create', body, true, false, {
                headers: { 'X-ResourceType': this.resourceTypeModel }
              })
              .then(() => {
                countIdx++;
                if (countIdx === this.productsModel.length && showToast) {
                  this.$store.dispatch('notify/needCheckNotifications', true);
                  this.$toast.open(this.$t('toast.eventPolicy.addSuccess'));
                  showToast = false;
                }
              })
              .catch(() => {
                countIdx++;
                if (countIdx === this.productsModel.length && showToast) {
                  this.$toast.open(this.$t('toast.eventPolicy.addFail'));
                  showToast = false;
                }
              });
          })();

          body.eventPolicyRequests = [];
          productsModelCnt++;
        }
        this._onConfirm();
      } else {
        for (let i in this.eventRules) {
          let policy = {};
          const rule = this.eventRules[i];
          policy.eventLevel = rule.eventLevel;
          policy.disableYn = rule.disableYn;
          policy.eventMessagePrefix = this.$util.isNotEmpty(rule.prefix) ? rule.prefix : '';

          policy.ftCount = Number(rule.ftCount);
          policy.isLogMetric = rule.isLogMetric ? rule.isLogMetric : 'N';
          policy.metricKey = rule.metricKey;

          policy.objectName = rule.objectModel;
          policy.objectDisplayName = rule.objectModelDisplay;
          policy.eventOccurTimeZone = rule.eventOccurTimeZone;
          // 단일상품일 경우
          if (rule.isObjectExist != 'Y') {
            if (Array.isArray(rule.objectItems) && rule.objectItems.length > 0) {
              let _objectModel =
                rule.objectItems.find((item) => {
                  return item.value == rule.objectModel;
                }) || {};
              policy.objectName = rule.objectModel;
              policy.objectDisplayName = _objectModel.text || rule.objectModel;
            }
          }

          if (this.is2ndDropDown) {
            policy.objectType = this.resourceTypeModel2;
            this.subResourceTypeData[this.resourceTypeModel].forEach((item) => {
              if (item.value == this.resourceTypeModel2) {
                policy.objectTypeName = `${item.text}`;
              }
            });
          } else {
            policy.objectType = '';
            policy.objectTypeName = '';
          }

          const newPolicy = handleValidPolicy(rule, policy);
          eventPolicyRequests.push(newPolicy);
        }
      }

      if (
        !this.is2ndDropDown ||
        (this.resourceTypeModel === 'Kubernetes' && this.resourceTypeModel2 === 'cluster') ||
        (['DataOps', 'DataFlow', 'Load Balancer'].includes(this.resourceTypeModel) &&
          this.resourceTypeModel2 === 'service') ||
        (['QuickQuery', 'DataWrangler'].includes(this.resourceTypeModel) &&
          this.resourceTypeModel2 === 'namespace')
      ) {
        body.eventPolicyRequests = eventPolicyRequests;

        var reducer = function (accumulator, item) {
          accumulator.push(Number(item.productSq));
          return accumulator;
        };
        let result = this.productsModel.reduce(reducer, []);

        body.notificationRecipients = this.getNotificationRecipients();

        body.productSqs = result;
        body.groupSqs = this.selectedASG.map((item) => item.groupSq);

        this.$http.event
          .post('/v1/console/event-policies/create', body, true, false, {
            headers: { 'X-ResourceType': this.resourceTypeModel }
          })
          .then(() => {
            if (showToast) {
              this.$store.dispatch('notify/needCheckNotifications');
              this.$toast.open(this.$t('toast.eventPolicy.addSuccess'));
              showToast = false;
            }
            this._onConfirm();
          })
          .catch(() => {
            if (this.showToast) {
              this.$toast.open(this.$t('toast.eventPolicy.addFail'));
              showToast = false;
            }
          });
      }
    },
    async getData() {
      const data = await this.$http.product.getProductSubTypes('N', 'eventSetting');

      this.$util.convertArr(data, { productTypeName: 'text', productTypeCode: 'value' });
      this.resourceTypeItems = data;
      this.productTypeGroups = await getProductTypeGroups(data);
      this.resourceTypeModel =
        this.resourceTypeItems.find((item) => item.productTypeCode === this.productTypeCode)
          ?.value || '';
      this.prevResourceTypeModel = this.resourceTypeModel;

      this.isDisabledBtn = !this.resourceTypeModel;
      this.isShowMessageNoProductType = !this.resourceTypeModel;
      this.isShowEventRule = true;

      this.isPassAuthorization = await this.checkProductSubTypeAuth(this.resourceTypeModel);
    },

    addMonitorVmPopupOnConfirm() {
      this.$refs.rule.resourceChanged(this.resourceTypeModel, this.showSubResource, false);
      this.chkMetricItems = false;
    },

    async checkProductSubTypeAuth(productTypeCode) {
      if (!productTypeCode) return false;
      const authData = await this.$store.dispatch('authStore/checkProductSubTypeAuthorization', {
        productTypeCode
      });
      return authData.type === this.$const.AuthorizationResult.ALLOW;
    },

    async selectResourceType(value) {
      const isEmpty = !this.resourceTypeModel;
      if (value) {
        this.resourceTypeModel = value;
        this.resourceTypeModel2 =
          Array.isArray(this.subResourceTypeData[this.resourceTypeModel]) &&
          this.subResourceTypeData[this.resourceTypeModel].length > 0
            ? this.subResourceTypeData[this.resourceTypeModel][0].value
            : '';
      }

      this.isDisabledBtn = false;
      this.isShowMessageNoProductType = false;

      const isPass = await this.checkProductSubTypeAuth(this.resourceTypeModel);

      if (isEmpty) {
        this.isPassAuthorization = isPass;
      }

      if (!isPass) {
        this.resourceTypeModel = this.prevResourceTypeModel;
        this.search1Codes.sch01 = this.preSch01;
        this.resourceTypeModel2 = this.prevResourceTypeModel2;
        this.isDisabledBtn = !this.resourceTypeModel;
        this.isShowMessageNoProductType = !this.resourceTypeModel;
        return;
      }

      if (this.resourceTypeModel == this.prevResourceTypeModel) {
        return;
      }
      if (!this.prevResourceTypeModel) {
        this.$nextTick(() => {
          this.$refs.rule.resourceChanged(this.resourceTypeModel);
        });
        this.typeIndex = 1;
        this.prevResourceTypeModel = value;
        this.prevResourceTypeModel2 = this.resourceTypeModel2;
        this.isCheckChangeData = true;
        return;
      }
      this.$modal.open({
        rootId: 'app',
        type: 'confirm',
        title: this.t('page.eventStatus.notice'),
        message: `<div>` + this.t('page.template.changeProductType') + `</div>`,
        action: () => {
          try {
            this.productsModel = [];
            this.beforeProductsModel = [];
            this.selectedASG = [];
            this.beforeSelectedASG = [];
            this.listChips = [];
            this.$refs.rule.opt = '';
            this.notificationsModel = [];
            this.$nextTick(() => {
              this.$refs.alarm.setNotifications();
            });
          } catch (error) {
            console.log(error);
          }
          this.$nextTick(() => {
            this.$refs.rule.resourceChanged(this.resourceTypeModel);
          });
          this.typeIndex = 1;
          this.prevResourceTypeModel = value;
          this.prevResourceTypeModel2 = this.resourceTypeModel2;
          if (!this.is2ndDropDown) {
            this.search1Codes.sch01 = [];
          }
          this.preSch01 = this.search1Codes.sch01;
          this.isCheckChangeData = true;
          this.isPassAuthorization = true;
          this.initial();
        },
        cancel: () => {
          this.resourceTypeModel = this.prevResourceTypeModel;
          this.search1Codes.sch01 = this.preSch01;
          this.resourceTypeModel2 = this.prevResourceTypeModel2;
          if (!this.resourceTypeModel) {
            this.isDisabledBtn = true;
          }
        }
      });
    },
    selectResourceType2(value) {
      this.resourceTypeModel2 = value;
      if (this.resourceTypeModel2 == this.prevResourceTypeModel2) {
        return;
      }

      this.$modal.open({
        rootId: 'app',
        type: 'confirm',
        title: this.t('title.notice'),
        message: `<div>` + this.t('page.template.changeProductType') + `</div>`,
        action: () => {
          try {
            this.productsModel = [];
            this.beforeProductsModel = [];
            this.listChips = [];
            this.$refs.rule.opt = '';
            this.$refs.rule.resourceChanged(this.resourceTypeModel);
            this.notificationsModel = [];
            this.$nextTick(() => {
              this.$refs.alarm.setNotifications();
            });
          } catch (error) {
            console.log(error);
          }
          this.prevResourceTypeModel2 = value;
          this.initial();
        },
        cancel: () => {
          this.resourceTypeModel2 = this.prevResourceTypeModel2;
        }
      });
    },
    addMonitorClick() {
      this.openingPopupMonTarget = true;
      this.openAddMonitorVmPopup();
    },
    /*************
     * modal
     *************/
    // 모달오픈 : Vm
    openAddMonitorVmPopup() {
      let item = this.resourceTypeItems.find((item) => item.value == this.resourceTypeModel);
      this.popup.addMonitorVmProps.pProductTypeCode = item.value;
      this.popup.addMonitorVmProps.pProductTypeName = item.text;
      this.popup.addMonitorVmProps.pProductTypeCodes = this.productsModel.map((item) => ({
        ...item,
        resourceId: item.productResourceId || item.resourceId
      }));
      this.popup.addMonitorVmProps.pObjectTypeCode = this.resourceTypeModel2;
    },
    initial() {
      this.eventRules = [];
    },
    async secondDropDownDataSetting() {
      for (let resourceType of this.lstSubResourceType) {
        this.subResourceTypeData[resourceType] = await this.$http.product.getListProductObjectTypes(
          resourceType
        );
      }
    },
    secondDropDownSetting() {
      if (this.lstSubResourceType.includes(this.resourceTypeModel)) {
        this.search1Codes.sch01 = this.subResourceTypeData[this.resourceTypeModel];
      } else {
        this.search1Codes.sch01 = [];
        this.resourceTypeModel2 = '';
      }
    },
    setMetricItems() {
      this.chkMetricItems = true;
    },
    getSubProductype() {
      if (this.subProductCode) {
        this.resourceTypeModel2 = this.subProductCode;
      } else {
        this.prevResourceTypeModel2 =
          Array.isArray(this.subResourceTypeData[this.productTypeCode]) &&
          this.subResourceTypeData[this.productTypeCode].length > 0
            ? this.subResourceTypeData[this.productTypeCode][0].value
            : '';
        this.resourceTypeModel2 = this.prevResourceTypeModel2;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  display: flex;
  height: 100%;
  flex-direction: column;

  .tabs-container {
    min-height: 0;
    height: 100%;

    .event-rule {
      height: 100%;
    }
  }
}

.notification-target {
  visibility: hidden;

  &__active {
    visibility: visible;
  }

  :deep(.lego-table .lego-table__control) {
    z-index: auto;
  }

  :deep(.list-select-table-wrap .lego-table) {
    position: relative;

    &::after {
      content: '';
      display: block;
      background-color: #8e9198;
      position: absolute;
      left: 0;
      width: 100% !important;
      bottom: 0;
      height: 1px;
    }
  }

  :deep(.list-select-table-wrap .lego-table .header-table) {
    height: 30px;

    th {
      border-bottom: 1px solid #8e9198;
    }
  }

  :deep(.list-select-table-wrap .lego-table .lego-table__no-data) {
    border-top: none;
  }

  :deep(.list-select-table-wrap .lego-table .lego-table__area-wrapper) {
    border-top: none;
    border-bottom: none;
  }
}

.event-alarm__setting {
  :deep(.select-list-wrap) {
    width: 304px;
    height: 265px;
  }

  :deep(.table-wrap) {
    width: calc(100% - 304px);
  }

  :deep(.list-select-table-wrap) {
    margin-top: 24px;
  }
}

.lego-tab__label-underline {
  color: #2e3138;
  border-bottom: 1px solid #e3e4e8;

  &--active {
    color: #2c5ad8;
    border-bottom-color: #2c5ad8;
  }
}

.lego-tab__label-underline:hover {
  color: #2c5ad8 !important;
}

:deep(.lego-tab__content-wrapper) {
  border-top: 1px solid #e3e4e8;
}

.tab-wrapper {
  position: relative;

  .action-wrapper {
    position: absolute;
    right: 0;
    top: 11px;
  }

  .tabbox {
    &-item {
      height: 54px;
      text-transform: capitalize;
      padding: 0 32px;
    }
  }
}

.subtitle {
  padding: 10px 0 0 0;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}

.subtitle .required {
  color: rgb(255, 0, 0);
}

.table-header-wrap {
  padding-bottom: 10px;

  &:after {
    content: '';
    clear: both;
    display: table;
  }

  & .left-con {
    float: left;
    width: 40%;
  }

  & .right-con {
    float: right;
    width: 60%;
    text-align: right;
  }
}

.lego-modal__container {
  height: 864px !important;
  max-height: 864px !important;
}

.table-body-wrap {
  :deep .added-list-box {
    margin-top: 0px;

    .box-title {
      span,
      .total-value:before {
        display: none !important;
      }
    }

    .lego-icon--small {
      width: 16px !important;
      height: 16px !important;
      margin-right: 6px;
      font-size: 16px !important;
      vertical-align: middle;
    }
  }
}

.tooltip {
  display: none;
}

.tooltip:hover {
  display: inline-block;
}

.badge-text-wrapper {
  display: flex;
  align-items: center;
}

:deep .listTargetItem {
  display: inline-block;
  color: #364fc7;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.badge-selected {
  width: 20px;
  height: 20px;
  border: 1px solid #2c59d9;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  margin-left: 8px;
  font-size: 12px;
  line-height: 12px;
  color: #2c59d9;
  font-weight: bold;
}

.wrap-title-tab-box {
  display: flex;
  align-items: center;
}
:deep(.add-monitor-target) {
  .dev_no-data {
    min-height: 464px !important;
  }
  .add-moni-target-sub-item {
    .dev_no-data {
      min-height: 458px !important;
    }
  }
}
:deep(.scpm-insight-chart-container) {
  width: unset !important;
}
.disable-click-title {
  :deep(strong) {
    cursor: default;
  }
  :deep(.formbox .form-header .left-con strong) {
    cursor: default;
    color: #2e3138;
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
